/**
 * Returns true if the value is a string.
 */
export const isString = (value: unknown): value is string =>
  typeof value === 'string'

/**
 * Capitalize first letter
 * @param string - String you'd like to capitalize the first letter
 * @returns String with the first letter capitalized
 */
export const capitalizeFirstLetter = (string: string) =>
  string.charAt(0).toUpperCase() + string.slice(1)

/**
 * Converts kebab-case string to camelCase
 * @param string - string in kebab-case format
 * @returns string in camelCase format
 * @example
 * kebabCaseToCamelCase('kebab-case') // 'kebabCase'
 * kebabCaseToCamelCase('kebab-case-string') // 'kebabCaseString'
 */
export const kebabCaseToCamelCase = (string: string) =>
  string.replace(/(-\w)/g, m => m[1].toUpperCase())

/**
 * Converts snake_case string to camelCase
 * @param string - string in snake_case format
 * @returns string in camelCase format
 * @example
 * snakeCaseToCamelCase('snake_case') // 'snakeCase'
 * snakeCaseToCamelCase('camelCase') // 'camelCase'
 */
export const snakeCaseToCamelCase = (string: string) =>
  string.replace(/(_\w)/g, m => m[1].toUpperCase())
